var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiBob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.550781,
    y: 0.923828,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#E42C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72688 7.72159C5.04262 7.72159 4.48828 7.16761 4.48828 6.4858C4.48828 5.80398 5.04262 5.25 5.72688 5.25C6.41115 5.25 6.96549 5.80398 6.96549 6.4858C6.96549 7.16761 6.41115 7.72159 5.72688 7.72159ZM5.72688 5.64205C5.25916 5.64205 4.87805 6.02557 4.87805 6.4858C4.87805 6.95455 5.25916 7.32955 5.72688 7.32955C6.19461 7.32955 6.57572 6.95455 6.57572 6.4858C6.57572 6.01705 6.19461 5.64205 5.72688 5.64205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1587 5.40394V4.33008C2.1587 4.17667 2.02878 4.04883 1.87287 4.04883C1.72563 4.04883 1.5957 4.17667 1.5957 4.33008V6.48633C1.5957 7.21076 2.19335 7.79883 2.92092 7.79883C3.65715 7.79883 4.24614 7.21076 4.24614 6.47781C4.24614 5.75337 3.64849 5.15678 2.92092 5.15678C2.63509 5.16531 2.37524 5.25053 2.1587 5.40394ZM2.92092 7.23633C2.49651 7.23633 2.1587 6.89542 2.1587 6.47781C2.1587 6.06019 2.50517 5.71928 2.92092 5.71928C3.34534 5.71928 3.68314 6.06019 3.68314 6.47781C3.6918 6.89542 3.34534 7.23633 2.92092 7.23633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35121 5.34464C7.96144 5.34464 7.62364 5.53214 7.41576 5.82191V4.20259C7.41576 4.14293 7.36379 4.0918 7.31182 4.0918C7.25119 4.0918 7.19922 4.14293 7.19922 4.20259V6.48668C7.19922 7.11737 7.71891 7.62873 8.35121 7.62873C8.99216 7.62873 9.50319 7.11737 9.50319 6.47816C9.51186 5.856 8.99216 5.34464 8.35121 5.34464ZM8.35121 7.42418C7.83151 7.42418 7.41576 7.00657 7.41576 6.49521C7.41576 5.98384 7.84017 5.56623 8.35121 5.56623C8.8709 5.56623 9.28666 5.98384 9.28666 6.49521C9.29532 6.99805 8.8709 7.42418 8.35121 7.42418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBob);
export default __webpack_public_path__ + "static/media/HiBob.96f2b3a69e85e97a9c0a198d065a4d0b.svg";
export { ForwardRef as ReactComponent };